module.exports = __webpack_public_path__ + "img/grenlander.2377c698.svg";